var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-select",
    {
      attrs: {
        loading: _vm.loadingListStatus,
        disabled: _vm.loadingListStatus,
        expanded: ""
      },
      model: {
        value: _vm.logsReverseStatus,
        callback: function($$v) {
          _vm.logsReverseStatus = $$v
        },
        expression: "logsReverseStatus"
      }
    },
    [
      _c("option", { domProps: { value: null } }, [
        _vm._v("\n    " + _vm._s(_vm.optionAll ? "Todos" : "Selecione"))
      ]),
      _vm._v(" "),
      _vm._l(_vm.listStatus, function(status) {
        return _c(
          "option",
          { key: status.value, domProps: { value: status.value } },
          [_vm._v("\n    " + _vm._s(status.label) + "\n  ")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b3daf00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3daf00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/reverse/components/sc-logs-reverse-status/ScLogsReverseStatus.vue
// module id = null
// module chunks = 